import React, { useContext } from 'react';
import { SessionResource } from '@clerk/types';
import {
  assertUserGuarantee,
  assertWrappedByClerkProvider,
} from './assertHelpers';
import { StructureContext } from './StructureContext';

type SessionContextValue = { value: SessionResource | null | undefined };
export const SessionContext = React.createContext<
  SessionContextValue | undefined
>(undefined);
SessionContext.displayName = 'SessionContext';

export function useSession(): SessionResource {
  const structureCtx = useContext(StructureContext);
  const sessionCtx = React.useContext(SessionContext);
  assertWrappedByClerkProvider(sessionCtx);
  assertWrappedByClerkProvider(structureCtx);
  assertUserGuarantee(structureCtx.guaranteedUser, 'useSession()');
  return sessionCtx.value as SessionResource;
}
